module.exports = __webpack_public_path__ + "img/location.fc22eb94.svg";